import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Prompt } from 'react-router-dom';
import { Card, Typography, IconButton } from '@totalsoft/rocket-ui';
import { Table, TableCell, TableBody, TableRow, TableHead } from '@mui/material';
import ViewList from '@mui/icons-material/ViewList';
import { getErrors } from '@totalsoft/pure-validations-react';
import ChecklistPropertyListItemComponent from './ChecklistPropertyListItemComponent';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';

const ChecklistPropertyListComponent = ({
  properties,
  checklistProperties,
  onSave,
  onAdd,
  onPropertyChanged,
  onDelete,
  validation,
  saveDisabled
}) => {
  const [t] = useTranslation();

  return (
    <Card
      icon={ViewList}
      iconColor='primary'
      title={t('Checklist.Properties')}
      actions={
        <>
          <IconButton type='add' fontSize='medium' color='transparent' tooltip={t('Tooltips.Add')} onClick={onAdd} />
          <IconButton
            type='save'
            fontSize='medium'
            color='transparent'
            tooltip={t('RequiredDocument.Save')}
            onClick={onSave}
            disabled={(validation |> getErrors) !== '' || saveDisabled || !properties.changed}
          />
        </>
      }
      footer={<Typography color='error'>{validation |> getErrors}</Typography>}
    >
      <>
        <Prompt when={properties.changed} message={t('Checklist.LeavingWithoutSavingChecklist')} />
        <CardNoResultsWrapper content={properties?.values}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: 1 / 2 }}>{t('RequiredDocument.Property')}</TableCell>
                <TableCell>{t('Checklist.DefaultValue')}</TableCell>
                <TableCell align='center'>{t('Checklist.MandatoryYN')}</TableCell>
                <TableCell align='right'>{t('Checklist.Actions')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {properties?.values.map((item, idx) => {
                return (
                  <ChecklistPropertyListItemComponent
                    property={item}
                    index={idx}
                    key={idx}
                    checklistProperties={checklistProperties}
                    onPropertyChanged={onPropertyChanged}
                    validation={validation}
                    onDelete={onDelete}
                  />
                );
              })}
            </TableBody>
          </Table>
        </CardNoResultsWrapper>
      </>
    </Card>
  );
};

ChecklistPropertyListComponent.propTypes = {
  properties: PropTypes.object.isRequired,
  checklistProperties: PropTypes.array,
  onSave: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  saveDisabled: PropTypes.bool.isRequired
};

export default ChecklistPropertyListComponent;
